import { Utils } from "@crispico/foundation-react";
import { Severity } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { addAfterStartupRunnable } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { addEntityDescriptor, EntityDescriptor, FieldDescriptor } from "@crispico/foundation-react/entity_crud/EntityDescriptor";
import { SliceEntityEditorPage } from "@crispico/foundation-react/entity_crud/EntityEditorPage";
import { FieldEditorProps } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { createSliceFoundation } from "@crispico/foundation-react/reduxHelpers";
import React from "react";
import { SAVE_USER, SAVE_USER_OPERATION_NAME } from "./queries";
import { UserEditorPage } from "./UserEditorPage";

export let userEntityDescriptor: EntityDescriptor;
export class SliceUserEditor extends SliceEntityEditorPage {
    protected handleDataReturnedBySaveOperation(dataReturnedBySave: any): void {
        if (dataReturnedBySave[SAVE_USER_OPERATION_NAME].notificationMessage) {
            Utils.showGlobalAlert({ message: dataReturnedBySave[SAVE_USER_OPERATION_NAME].notificationMessage, severity: Severity.INFO });
        }
    }

    protected getSaveOperationName(): string {
        // We override it because by default is 'userService_save'
        return SAVE_USER_OPERATION_NAME;
    }

    /**
     * Meant to be overwritten
     */
    protected shouldOverrideSaveMutationEntirely(): boolean {
        return true;
    }

    protected initQueries() {
        super.initQueries();
        if (this.shouldOverrideSaveMutationEntirely()) {
            this.saveMutation = SAVE_USER;
        }
    }

    /**
     * TODO DB: Temporary untill the mechanism for displaying the validation errors will be implemented
     */
    protected isDefaultErrorHandlerShownInCaseOfValidationException(): boolean {
        return true;
    }
}

addAfterStartupRunnable(() => {
    userEntityDescriptor = addEntityDescriptor(new EntityDescriptor({
        name: "User",
        icon: "user",
        miniFields: ["username"]
    })
        .addTabDescriptor({ oneToManyEntityName: "UserToOrganization", oneToManyOppositeField: "user" })
        .addFieldDescriptor({ name: "id", type: FieldType.number, enabled: false })
        .addFieldDescriptor({ name: "username", type: FieldType.string })
        .addFieldDescriptor({ name: "email", type: FieldType.string })
        .addFieldDescriptor({ name: "firstName", type: FieldType.string })
        .addFieldDescriptor({ name: "lastName", type: FieldType.string })
        .addFieldDescriptor({ name: "language", type: FieldType.dropdown})
        .addFieldDescriptor({ name: "isAdmin", type: FieldType.boolean })
        .addFieldDescriptor({ name: "resetKey", type: FieldType.string })
        .addFieldDescriptor({ name: "resetDate", type: FieldType.date })
        .addFieldDescriptor({ name: "passwordExpires", type: FieldType.boolean, defaultValue: true })
        .addFieldDescriptor({ name: "passwordChangedDate", type: FieldType.date })
        .addFieldDescriptor({ name: "failedLoginAttempts", type: FieldType.number })
        .addFieldDescriptor({ name: "isLocked", type: FieldType.boolean })
        .addFieldDescriptor({ name: "lastLoginDate", type: FieldType.date })
        .addFieldDescriptor({ name: "creationDate", type: FieldType.date })
        .doForFields(["resetKey", "resetDate", "passwordChangedDate", "lastLoginDate", "creationDate"],
            fieldDescriptor => { fieldDescriptor.isInDefaultColumnConfigForTable = false; fieldDescriptor.isInDefaultColumnConfigForEditor = false; })
        .removeFieldDescriptors("newPassword", "screen", "screenposition", "pricesAvailable", "showDoneTasksInFlightGantt", "showDoneTasksInMissionGantt", "unit", "initialConfiguration")
    );

    const sliceUserEditor = createSliceFoundation(SliceUserEditor);
    userEntityDescriptor.infoEditor.slice = sliceUserEditor;
    sliceUserEditor.setEntityDescriptor(userEntityDescriptor);

    userEntityDescriptor.infoEditor.wrappedComponentClass = UserEditorPage;
})